import React from 'react';
import { NavLink } from 'react-router-dom';
import { Book, GamepadIcon, Store, Trophy } from 'lucide-react';

const NavBar = () => {
  return (
    <nav className="bg-blue-50 border-b-2 border-blue-600 shadow-sm fixed top-0 left-0 right-0 z-50">
      <div className="max-w-4xl mx-auto px-4">
        <div className="flex items-center justify-between h-14">
          {/* Logo/Title Section */}
          <div className="flex items-center">
            <span className="text-blue-900 font-bold text-xl" style={{ fontFamily: 'serif' }}>
              Epikon
            </span>
          </div>

          {/* Navigation Links */}
          <div className="flex space-x-1">
            <NavLink
              to="/greek-text"
              className={({ isActive }) => `
                px-3 py-2 rounded-lg flex items-center space-x-1
                transition-colors duration-200
                ${isActive 
                  ? 'bg-blue-100 text-blue-900' 
                  : 'text-blue-700 hover:bg-blue-100'
                }
              `}
            >
              <Book className="w-4 h-4" />
              <span className="text-sm font-medium">Lessons</span>
            </NavLink>

            <NavLink
              to="/game1"
              className={({ isActive }) => `
                px-3 py-2 rounded-lg flex items-center space-x-1
                transition-colors duration-200
                ${isActive 
                  ? 'bg-blue-100 text-blue-900' 
                  : 'text-blue-700 hover:bg-blue-100'
                }
              `}
            >
              <GamepadIcon className="w-4 h-4" />
              <span className="text-sm font-medium">Games</span>
            </NavLink>

            <NavLink
              to="/store"
              className={({ isActive }) => `
                px-3 py-2 rounded-lg flex items-center space-x-1
                transition-colors duration-200
                ${isActive 
                  ? 'bg-blue-100 text-blue-900' 
                  : 'text-blue-700 hover:bg-blue-100'
                }
              `}
            >
              <Store className="w-4 h-4" />
              <span className="text-sm font-medium">Store</span>
            </NavLink>

            <NavLink
              to="/trophy-room"
              className={({ isActive }) => `
                px-3 py-2 rounded-lg flex items-center space-x-1
                transition-colors duration-200
                ${isActive 
                  ? 'bg-blue-100 text-blue-900' 
                  : 'text-blue-700 hover:bg-blue-100'
                }
              `}
            >
              <Trophy className="w-4 h-4" />
              <span className="text-sm font-medium">Trophy Shrine</span>
            </NavLink>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;